// 9fbef606107a605d69c0edbcd8029e5d
import { CONFIRMATION_ACTION_PATTERN } from '../../../../constants/reducer.constants';

const CONFIRMATION_CONSTANTS = {
  CONFIRMATION_SET_ORDER_CONFIRMATION: `${CONFIRMATION_ACTION_PATTERN}CONFIRMATION_SET_ORDER_CONFIRMATION`,
  CONFIRMATION_SET_ORDER_PRODUCTS: `${CONFIRMATION_ACTION_PATTERN}CONFIRMATION_SET_ORDER_PRODUCTS`,
  CONFIRMATION_SET_VENMO_PAYMENT_MESSAGE_DISPLAYED: `${CONFIRMATION_ACTION_PATTERN}CONFIRMATION_SET_VENMO_PAYMENT_MESSAGE_DISPLAYED`,
  CONFIRMATION_SET_REWARDS_POINTS: `${CONFIRMATION_ACTION_PATTERN}CONFIRMATION_SET_REWARDS_POINTS`,
  CONFIRMATION_VALUES_COUPONS_SET: `${CONFIRMATION_ACTION_PATTERN}CONFIRMATION_VALUES_COUPONS_SET`,
  CONFIRMATION_FETCH_UPDATE_ORDER_DETAILS: `${CONFIRMATION_ACTION_PATTERN}CONFIRMATION_FETCH_UPDATE_ORDER_DETAILS`,
  CONFIRMATION_SET_UPDATE_ORDER_DETAILS: `${CONFIRMATION_ACTION_PATTERN}CONFIRMATION_SET_UPDATE_ORDER_DETAILS`,
  CONFIRMATION_SET_ORDER_DETAILS: `${CONFIRMATION_ACTION_PATTERN}CONFIRMATION_SET_ORDER_DETAILS`,
  SET_EBBO_OFFERS: `${CONFIRMATION_ACTION_PATTERN}SET_EBBO_OFFERS`,
  FETCH_EBBO_OFFERS: `${CONFIRMATION_ACTION_PATTERN}FETCH_EBBO_OFFERS`,
  SET_EBBO_MODAL_OPEN: `${CONFIRMATION_ACTION_PATTERN}SET_EBBO_MODAL_OPEN`,
  ORDER_ITEM_TYPE: {
    BOSS: 'BOSS',
    BOPIS: 'BOPIS',
    ECOM: 'ECOM',
    PURE_ECOM: 'PURE_ECOM',
  },
  DATE_OPTIONS: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  },
  CONFIRMATION_SET_CREATE_ACCOUNT_SUCCESS: `${CONFIRMATION_ACTION_PATTERN}CONFIRMATION_SET_CREATE_ACCOUNT_SUCCESS`,
  SUCCESS_MESSAGE_TIME_MS: 5000,
  CONFIRMATION_DIALOG_TIME_MS: 5000,
  CONFIRMATION_LOCAL_DATE_FORMATE: 'en-US',
  CONFIRMATION_SMS_NOTIFICATION: `${CONFIRMATION_ACTION_PATTERN}CONFIRMATION_SMS_NOTIFICATION`,
  CONFIRMATION_SMS_NOTIFICATION_ERR: `${CONFIRMATION_ACTION_PATTERN}CONFIRMATION_SMS_NOTIFICATION_ERR`,
  RESET_CONFIRMATION_SMS_NOTIFICATION_ERR: `${CONFIRMATION_ACTION_PATTERN}RESET_CONFIRMATION_SMS_NOTIFICATION_ERR`,
  SET_LOADING_STATE: `${CONFIRMATION_ACTION_PATTERN}SET_LOADING_STATE`,
  SET_COUPON_LOADING_STATE: `${CONFIRMATION_ACTION_PATTERN}SET_COUPON_LOADING_STATE`,
  CONFIRMATION_SET_SMS_NOTIFICATION_SUCCESS: `${CONFIRMATION_ACTION_PATTERN}CONFIRMATION_SET_SMS_NOTIFICATION_SUCCESS`,
  COMPLETEDFIRSTCHECKOUT: 'completedFirstCheckout',
  CONFIRMATION_COMPLETED: `${CONFIRMATION_ACTION_PATTERN}CONFIRMATION_COMPLETED`,
  SET_CREATE_ACCOUNT_LOADER: `${CONFIRMATION_ACTION_PATTERN}SET_CREATE_ACCOUNT_LOADER`,
  ACTIVE_CARD_CLASS: 'active-card',
  CARD_SECTION: {
    CREATE_ACCOUNT: 'CREATE_ACCOUNT',
    JOIN_TEXT_ALERTS: 'JOIN_TEXT_ALERTS',
  },
  HIDE_CREATE_ACCOUNT_FORM: `${CONFIRMATION_ACTION_PATTERN}HIDE_CREATE_ACCOUNT_FORM`,
  INIT_CONFORMATION_PAGE: 'INIT_CONFORMATION_PAGE',
  CONFIRMATION_RATING_POP_UP_SHOWN: '_confirmation_rating-pop-up_shown',
  CONFIRMATION_RATING_POP_UP_RATE_US: '_confirmation_rating-pop-up_shown_rate_us',
  CONFIRMATION_RATING_POP_UP_NEXT_TIME: '_confirmation_rating-pop-up_shown_next_time',
  ORDER_CONFIRMATION_MODAL_HEADING: 'Want real-time order updates?',
  ORDER_CONFIRMATION_MODAL_CANCEL_TEXT: 'cancel',
  ORDER_CONFIRMATION_MODAL_APPNOTIFY_TEXT: 'Turn on app notifications now!',
  ORDER_CONFIRMATION_MODAL_TRACKSHIP_DELIVERY: 'Track shipping & delivery updates',
  ORDER_CONFIRMATION_MODAL_SHOP_ARRIVALS: 'Shop new arrivals & special promos first!',
  ORDER_CONFIRMATION_MODAL_NOTIFY_ME: 'Notify Me',
  ORDER_CONFIRMATION_MODAL_SUCCESS_BAR_TITLE: 'All set! Keep a lookout for your notifications.',
};

export default CONFIRMATION_CONSTANTS;
